/**
 * 2019-04-04
 * handan
 * 调查结果从新查询数据
 */

import { ajax } from "../utils/http/http";
import handleError from "../utils/handleError";

const getFreeInquiry = async (params)=>{
  let data = await ajax("/58/record/freeInquiry","POST",params);
  if(data.code==="1"){
    return Promise.resolve(data.data);
  }else{
    return handleError(data);
  }
  
}

export default getFreeInquiry;